import { Flex } from 'antd';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MEDIA_QUERIES } from 'src/enums';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import LocaleContext from 'src/LocaleContext';
import { userSelectors, useSelector } from 'src/store';
import { useTheme } from 'src/styles/theme';

import AppCenterModal from '../appCenterModal';
import AppDivider from '../appDivider';
import FullScreenModal from '../fullScreenModal';
import classes from './style/TakanonModal.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITakanonModalProps {}

const TakanonModal: React.FunctionComponent<ITakanonModalProps> = (props) => {
  // TOOLS
  const { t } = useTranslation();
  const { locale } = useContext(LocaleContext);
  const { width } = useWindowDimensions();
  const theme = useTheme();
  // STATE
  const [isTakanonModalOpen, setTakanonModalOpen] = React.useState(false);

  // SELECTORS
  const hospital = useSelector(userSelectors.selectUserHospital);

  const openTakanonModal = () => {
    setTakanonModalOpen(true);
  };

  const closeTakanonModal = () => {
    setTakanonModalOpen(false);
  };

  const renderTakanon = () => {
    if (!hospital) return '';

    const hebrewInHospital = hospital.languages?.find(
      (l: { language: string }) => l.language === 'he'
    );

    const languageInHospital = hospital.languages?.find(
      (l: { language: string }) => l.language === locale
    );
    if (languageInHospital) {
      return languageInHospital.takanon;
    }
    if (hebrewInHospital?.takanon) {
      return hebrewInHospital.takanon;
    }
  };

  function hasTextWithinTags(text: string | undefined) {
    if (!text) return '';
    const regex = /<[^>]*>[^<]+<\/[^>]*>/g;
    const matches = text.match(regex);
    if (matches) {
      return matches.some((match) => /<[^>]*>[^<]+<\/[^>]*>/.test(match));
    }
    return false;
  }

  const renderTakanonContent = () => {
    return (
      <div className={classes.modalContent}>
        <h1
          className={`${theme.fonts.classNames.pageTitle} ${classes.modalTitle}`}
        >
          {t('login.takanon')}
        </h1>
        <AppDivider mt={40} mb={40} />
        <div
          className={`${classes.modalText} ${theme.fonts.classNames.subPageTitle}`}
          dangerouslySetInnerHTML={{ __html: renderTakanon() || '' }}
        />
      </div>
    );
  };

  return (
    <div>
      {hasTextWithinTags(renderTakanon()) && (
        <Flex align="center" justify="flex-start">
          <input type="checkbox" id="takanonCheckbox" />
          <label
            htmlFor="takanonCheckbox"
            className={`${theme.fonts.classNames.comment}`}
          >
            {t('login.agreeToTakanon')}
            <span onClick={openTakanonModal} className={classes.takanonLink}>
              {t('login.hospitalTakanon')}
            </span>
          </label>
        </Flex>
      )}

      {width && width < MEDIA_QUERIES.TABLET ? (
        <FullScreenModal
          visible={isTakanonModalOpen}
          closeModal={closeTakanonModal}
        >
          {renderTakanonContent()}
        </FullScreenModal>
      ) : (
        <AppCenterModal
          visible={isTakanonModalOpen}
          closeModal={closeTakanonModal}
        >
          {renderTakanonContent()}
        </AppCenterModal>
      )}
    </div>
  );
};

export default TakanonModal;
